import { useState } from "react";
import Cookies from "js-cookie";

const useToken = () => {
  const [token, setToken] = useState(() => Cookies.get("token"));

  // Function to set the token in state and in cookies
  const saveToken = (userToken) => {
    Cookies.set("token", userToken, {
      expires: 1,
      //TODO : Uncomment before going into Production
      secure: true,
      sameSite: "Strict",
    });
    setToken(userToken);
  };

  // Function to remove the token from state and cookies
  const removeToken = () => {
    Cookies.remove("token");
    setToken(null);
  };

  // Return the token and the functions to manage it
  return {
    setToken: saveToken,
    token: Cookies.get("token"),
    removeToken,
  };
};

export default useToken;
